module.exports = __webpack_public_path__ + "img/5d96b31.png";